import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  Grid,
  withStyles,
  Button,
  DialogActions,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  Select,
  MenuItem,
  Tooltip,
  FormControl,
  TextField,
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import PageTitle from '../../components/PageTitle/PageTitle';
import IconButton from '@material-ui/core/IconButton';
import * as Icons from '@material-ui/icons';
import { Link } from 'react-router-dom';
import Loader from '../../components/Loader/LoaderView';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage, setSelectTenant } from '../../utils/common';
import CustomFooter from '../../components/Table/CustomFooter';
import SelectTenant from '../../components/Select/SelectTenant';

class UsersManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant: 0,
      roleId: null,
      roleName: null,
      userId: '',
      loading: false,
      dialogAddopen: false,
      routers: [],
      dialogUpdatePasswordOpen: false,
      newPassword: '',
      confirmNewPassword: '',
      passwordError: false,
      profileToResetPassword: null,
    };
  }

  async componentDidMount() {
    const { offset, limit, search, sort, order, action, tenantIds } = this.props.user.toJS();
    if (action) {
      this.setState({
        tenant: tenantIds && tenantIds.length > 0 ? JSON.stringify(tenantIds) : 0,
      });
      await this.props.user.getUser(offset, limit, search, sort, order, tenantIds);
      this.props.user.setAction('action', null);
    } else {
      const tenantIds = localStorage.getItem('select_tenant') ? [+localStorage.getItem('select_tenant')] : null;
      this.setState({
        tenant: tenantIds ? JSON.stringify(tenantIds) : 0,
      });

      this.props.user.resetData();
      await this.props.user.setData('tenantIds', tenantIds);
      // await this.props.user.getUser();
    }
    await this.props.role.getRole(0, 0);
  }

  deleteItem(user) {
    const { t } = this.props;
    let userId = user[0];
    let userName = user[1];
    Swal.fire({
      html: `<h4>${t('user_remove_account').replace('x', userName)}`,
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('remove')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.user.deleteUser(userId);
          if (result.statusCode === 200) {
            Swal.fire({
              html: `<h4>${t('remove_success')}`,
              type: 'success',
            }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                const { offset, limit, search, sort, order, tenantIds } = this.props.user.toJS();
                await this.props.user.getUser(offset, limit, search, sort, order, tenantIds);
              }
            });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_remove')}`, type: 'error' });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_remove')}`, type: 'error' });
          }
        }
      }
    });
  }

  assignRole = async (data) => {
    if (data) {
      let userId = data[0];
      let roleId = data[3];
      this.setState((data) => {
        data.dialogAddopen = true;
        data.userId = userId;
        data.roleId = roleId;
        return data;
      });
    }
  };

  handleClose = () => {
    this.setState((data) => {
      data.dialogAddopen = false;
      return data;
    });
  };

  handleSubmit = async () => {
    const { t } = this.props;
    const { roleId, userId } = this.state;
    try {
      const result = await this.props.user.assignRole(roleId, userId);
      if (result.statusCode === 200) {
        this.setState((data) => {
          data.dialogAddopen = false;
          return data;
        });
        Swal.fire({
          html: `<h4>${t('assign_role_success')}`,
          type: 'success',
        }).then(async (resultSuccess) => {
          if (resultSuccess.value) {
            const { offset, limit, search, sort, order, tenantIds } = this.props.user.toJS();
            await this.props.user.getUser(offset, limit, search, sort, order, tenantIds);
          }
        });
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_assign_role')}`, type: 'error' });
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_assign_role')}`, type: 'error' });
      }
    }
  };

  onRoleChange = (e) => {
    const id = e.target.value;
    this.setState((prevState) => {
      prevState.roleId = id;
      return prevState;
    });
  };

  handleChangeTenant = async (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });

    const tenantIds = JSON.parse(value);
    await this.props.user.setData('tenantIds', tenantIds);
    setSelectTenant(tenantIds);
  };

  createUser() {
    const { classes, t } = this.props;
    return (
      <Button
        variant='outlined'
        color='primary'
        onClick={() => this.props.history.push('users/create')}
        className={classes.button}
      >
        <Icons.Add />
        {t('create_user')}
      </Button>
    );
  }

  titleContent() {
    const { classes, t } = this.props;
    const { search } = this.props.user.toJS();
    return (
      <div className={classes.titleBar}>
        <SelectTenant handleChangeTenant={this.handleChangeTenant} tenant={this.state.tenant} />
        <Grid className={classes.search}>
          <FormControl variant='outlined' className={classes.formControl} fullWidth>
            <TextField
              variant='outlined'
              size='small'
              value={search || ''}
              name='search'
              id='search'
              className={classes.contentInput}
              placeholder={t('search')}
              onChange={(e) => this.handleChangeSearch(e)}
            ></TextField>
          </FormControl>
        </Grid>
      </div>
    );
  }

  handleChangeSearch = (event) => {
    const { value } = event.target;
    this.props.user.setData('offset', 0, false);
    this.props.user.setData('search', value);
  };

  validateTableRow = (data, expectedSize) => {
    return data && Array.isArray(data) && data.length === expectedSize;
  };

  validateDeleteUser = (data) => {
    const userId = data[0];
    const roleId = data[3];
    if (localStorage.getItem('role_id') === '1') {
      return +localStorage.getItem('user_id') === userId;
    }
    // user ที่ไม่ใช่ role super admin
    return roleId !== 1 && +localStorage.getItem('user_id') === userId;
  };

  handleChangeRowsPerPage = (value) => {
    this.props.user.setData('limit', value);
  };

  handlechangePage = (value) => {
    const { limit } = this.props.user.toJS();
    this.props.user.setData('offset', value * limit);
  };

  getTenantName = (tenantDatas) => {
    let tenantName = '';
    const tenants = [];
    if (tenantDatas && tenantDatas.length > 0) {
      tenantDatas.forEach((t) => {
        tenantName = tenantDatas[0].name;
        tenants.push(t.name);
        // if (index > 0) {
        //   tenants.push(t.name)
        // } else {
        //   tenantName = t.name;
        // }
      });
    }
    return {
      tenantName: `${tenantName} ${tenants.length > 1 ? `(+${tenants.length})` : ''}`,
      tenants,
    };
  };

  handleOpenPasswordDialog = (profile) => {
    this.setState({ profileToResetPassword: profile })
    this.setState({ dialogUpdatePasswordOpen: true });
  };

  handleClosePasswordDialog = () => {
    this.setState({ dialogUpdatePasswordOpen: false, newPassword: '', confirmNewPassword: '', passwordError: false });
  };

  handlePasswordChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  validatePassword = () => {
    const { newPassword, confirmNewPassword } = this.state;
    if (newPassword !== confirmNewPassword) {
      this.setState({ passwordError: true });
      return false;
    }
    this.setState({ passwordError: false });
    return true;
  };

  handleSubmitPassword = async () => {
    const { t } = this.props;

    if (this.validatePassword()) {
      try {
        const result = await this.props.user.resetPasswordByAdmin(this.state.profileToResetPassword[0], this.state.newPassword);
        if (result.statusCode === 200) {
          Swal.fire({
            html: `<h4>${t('update_success')}`,
            type: 'success',
          }).then(async (resultSuccess) => {
            // if (resultSuccess.value) {
            //   const { offset, limit, search, sort, order, tenantIds } = this.props.user.toJS();
            //   await this.props.user.getUser(offset, limit, search, sort, order, tenantIds);
            // }
          });
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
        }
      } catch (e) {

      } finally {
        this.handleClosePasswordDialog();
      }
    };
  }
  render() {
    const { loading, users, search, sort, order, limit } = this.props.user.toJS();
    const { roles } = this.props.role.toJS();
    const { classes, t } = this.props;
    const page = users.data ? users.pagination.page - 1 : 0;
    const count = users.data ? users.pagination.count : 0;
    const ARRAYSIZE = 7;
    const columns = [
      {
        name: 'id',
        label: `${t('user_id')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'id' && order ? order : 'none',
        },
      },
      {
        name: 'userName',
        label: `${t('username')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'userName' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[1]}</div>;
          },
        },
      },
      {
        name: `fullname`,
        label: `${t('name')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'fullname' && order ? order : 'none',
          customBodyRender: (_, tableMeta) => {
            const row = tableMeta.rowData;
            const fullname = this.validateTableRow(row, ARRAYSIZE) ? row[2] : '';

            return <div className={classes.columnWidth300}>{fullname ? fullname : '-'}</div>;
          },
        },
      },
      {
        name: 'roles.name',
        label: `${t('role')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'roles.name' && order ? order : 'none',
          customBodyRender: (_, tableMeta) => {
            const row = tableMeta.rowData;
            // const roleId = this.validateTableRow(row, ARRAYSIZE) ? row[2] : ''
            // const role = roles.find(item => item.id === roleId)
            const roleName = this.validateTableRow(row, ARRAYSIZE) ? row[3] : '';

            return <div className={classes.columnWidth200}>{roleName ? roleName : '-'}</div>;
          },
        },
      },
      {
        name: 'roleId',
        label: `roleId`,
        options: {
          display: false,
        },
      },
      {
        name: 'tenants',
        label: `${t('tenant')}`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            const tenants = this.validateTableRow(row, ARRAYSIZE) ? row[5] : [];
            const tenantInfo = this.getTenantName(tenants);
            return (
              <div className={classes.columnWidth200}>
                <Tooltip
                  title={
                    tenantInfo.tenants.length > 1 ? (
                      <div>
                        {tenantInfo.tenants.map((t, i) => (
                          <div key={i}>{t}</div>
                        ))}
                      </div>
                    ) : (
                      ''
                    )
                  }
                  classes={{ tooltip: classes.tooltipFont }}
                >
                  <div>{tenantInfo.tenantName}</div>
                </Tooltip>
              </div>
            );
          },
        },
      },
      {
        name: '',
        label: `${t('action')}`,
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={classes.actionBox}>
                {/* {localStorage.getItem("role_id") === "1" &&
                  <Link to={`/app/users/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/tenant`}>
                    <Button variant="outlined" color="primary" className={classes.button}>{t('add_tenant')}</Button>
                  </Link>
                } */}
                {/* <Button variant="outlined" color="primary" className={classes.button} onClick={() => this.assignRole(row ? row : null)}>{t('add_role')}</Button> */}
                {/* <Link to={`/app/users/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/manage`}>
                  <Button variant="outlined" color="primary" className={classes.button}>{t('add_view')}</Button>
                </Link> */}
                <Link to={`/app/users/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/view`} title={t('view')}>
                  <IconButton>
                    {' '}
                    <Icons.FormatListBulleted color='primary' />
                  </IconButton>
                </Link>
                <Link to={`/app/users/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/edit`} title={t('edit')}>
                  <IconButton>
                    {' '}
                    <Icons.Edit color='primary' />
                  </IconButton>
                </Link>
                {(localStorage.getItem('role') === 'Super admin' || localStorage.getItem('role') === 'Admin') && (
                  <>
                    <IconButton
                      title={t('changePassword')}
                      onClick={() => this.handleOpenPasswordDialog(row)}
                      color='primary'
                      aria-label='password'
                    >
                      <Icons.Lock />
                    </IconButton>
                    <IconButton
                      title={t('delete')}
                      onClick={() => this.deleteItem(this.validateTableRow(row, ARRAYSIZE) ? row : '')}
                      disabled={this.validateDeleteUser(row)}
                      color='primary'
                      aria-label='delete'
                    >
                      <Icons.Delete />
                    </IconButton>

                  </>
                )}

              </div>
            );
          },
        },
      },
    ];

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <PageTitle title={t('all_users')} button={this.createUser()}>
          {this.titleContent()}
        </PageTitle>
        <Grid className={classes.mainContain} container spacing={32}>
          <Grid item xs={12}>
            <MUIDataTable
              data={users.data}
              columns={columns}
              options={{
                count: users.data ? users.pagination.count : 0,
                page: users.data ? users.pagination.page - 1 : 0,
                searchText: search,
                serverSide: true,
                pagination: true,
                onTableChange: (action, tableState) => {
                  // console.log(action, tableState);
                  switch (action) {
                    case 'changePage':
                      this.props.user.setData('offset', tableState.page * tableState.rowsPerPage);
                      // this.props.user.setData('page',tableState.page);
                      break;
                    case 'changeRowsPerPage':
                      this.props.user.setData('limit', tableState.rowsPerPage);
                      break;
                    case 'search':
                      this.props.user.setData('offset', 0, false);
                      this.props.user.setData('search', tableState.searchText);
                      break;
                    case 'sort':
                      const sortList = tableState.announceText.split(' ');
                      this.props.user.setData('offset', 0, false);
                      this.props.user.setData('sort', sortList[4], false);
                      this.props.user.setData('order', sortList[6] === 'descending' ? 'desc' : 'asc');
                      break;
                    default:
                      break;
                  }
                },
                print: false,
                download: false,
                viewColumns: false,
                search: false,
                sortFilterList: true,
                sort: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: false,
                filterType: 'dropdown',
                responsive: 'scrollFullHeight',
                rowsPerPageOptions: [10, 15, 50],
                rowsPerPage: limit,
                customFooter: (rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
                  return (
                    <CustomFooter
                      count={count}
                      page={page}
                      rowsPerPage={limit}
                      changeRowsPerPage={this.handleChangeRowsPerPage}
                      changePage={this.handlechangePage}
                      textLabels={textLabels}
                      rowsPerPageOptions={[10, 15, 50]}
                    />
                  );
                },
              }}
            />
          </Grid>
        </Grid>

        <Dialog
          onClose={this.handleClose}
          open={this.state.dialogAddopen}
          aria-labelledby='form-dialog-title'
          maxWidth='sm'
          fullWidth
        >
          <DialogTitle className='header' id='form-dialog-title'>
            {t('select_role')}
          </DialogTitle>
          <DialogContent>
            <Grid>
              <Grid item xs={12} className='deviceSelect'>
                <Paper className={`${classes.root} selectInput`}>
                  <Select
                    value={this.state.roleId || 0}
                    onChange={(e) => {
                      this.onRoleChange(e);
                    }}
                    inputProps={{
                      name: 'assing-role',
                      id: 'assing-role',
                    }}
                  >
                    <MenuItem fullwidth='true' key={9999999} value={0}>
                      {t('please_select_role')}
                    </MenuItem>
                    {(roles.data || []).map((val) => (
                      <MenuItem
                        fullwidth='true'
                        key={val.id}
                        value={val.id}
                        disabled={val.id === 1 && localStorage.getItem('role_id') !== '1' ? true : false}
                      >
                        {`${val.name || 'role name'}`}
                      </MenuItem>
                    ))}
                  </Select>
                </Paper>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button onClick={this.handleClose} color='default'>
                  {t('cancel')}
                </Button>
                <Button onClick={this.handleSubmit} color='primary' className={classes.button}>
                  {t('save')}
                </Button>
              </div>
            </Grid>
          </DialogActions>
        </Dialog>

        <Dialog
          onClose={this.handleClosePasswordDialog}
          open={this.state.dialogUpdatePasswordOpen}
          aria-labelledby='form-dialog-title'
          maxWidth='sm'
          fullWidth
        >
          <DialogTitle id='form-dialog-title'>
            {t('changePassword')}{t('user')} {this.state?.profileToResetPassword ? this.state?.profileToResetPassword[1] : ''}
          </DialogTitle>
          <DialogContent>
            <TextField
              variant='outlined'
              autoFocus
              margin='dense'
              name='newPassword'
              label={t('newPassword')}
              type='password'
              fullWidth
              value={this.state.newPassword}
              onChange={this.handlePasswordChange}
              error={this.state.passwordError}
              helperText={this.state.passwordError ? t('passwords_dont_match') : ''}
            />
            <TextField
              variant='outlined'
              margin='dense'
              name='confirmNewPassword'
              label={t('confirm_new_password')}
              type='password'
              fullWidth
              value={this.state.confirmNewPassword}
              onChange={this.handlePasswordChange}
              error={this.state.passwordError}
              helperText={this.state.passwordError ? t('passwords_dont_match') : ''}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClosePasswordDialog} color='default'>
              {t('cancel')}
            </Button>
            <Button onClick={this.handleSubmitPassword} color='primary'>
              {t('save')}
            </Button>
          </DialogActions>
        </Dialog>

      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    height: '38px',
    margin: theme.spacing.unit / 2,
    marginTop: 11,
  },
  actionBox: {
    minWidth: '370px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  columnWidth300: {
    maxWidth: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tooltipFont: {
    fontSize: '15px',
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  search: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
});

export const page = inject('user', 'role')(observer(UsersManager));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
